export const FAQUrl = "https://faq.wint.se";
export const FAQPageUrl = "faq-fragor";
export const Article1Url = "hur-skickar-jag-in-mina-leverantorsfakturor-till-wint";
export const Article2Url = "hur-hanterar-jag-kreditfakturor-i-wint";
export const Article3Url = "kreditera-kundfaktura";
export const ArticleDocumentEmailUrl = "tips/sa-fungerar-underlagsmailadressen";
export const ArticleSelfInvoiceEmailUrl = "faq-fragor/hur-registrerar-jag-sjalvfakturor";
export const RevisorArticle1Url = "glapp-i-nummerserien";
export const RevisorArticle2Url = "hur-kan-jag-se-underlagen-till-verifikationerna";
export const RevisorArticle3Url = "kan-ni-pa-wint-lamna-in-arsredovisningen-digitalt";
export const RevisorArticlesAllUrl = "faq/revisorer";
export const FAQServiceTimeountMs = 10 * 1000;
export const SupplierInvoiceUrl = "hur-skickar-jag-in-mina-leverantorsfakturor-till-wint";